import { supabase } from '../client';
import { logger } from '@deskbay/shared';

export async function updateProfile(userId: string, userData: { firstName: string; lastName: string; phone?: string; lang?: string; email?: string }) {
    const payload: Record<string, string | null> = {
      first_name: userData.firstName,
      last_name: userData.lastName,
      phone: userData.phone || null,
      lang: userData.lang || 'it'
    };
    if (userData.email) {
      payload.email = userData.email;
    }

    const { error } = await supabase
      .from('profiles')
      .update(payload)
      .eq('id', userId);

    if (error) {
      logger.api.error('Error updating profile', error, 'database.updateProfile');
      throw error;
    }
}
